import { useState, useEffect, useCallback } from 'react'
import { obtenerClientes, buscarClientes, guardarCliente, eliminarCliente } from '../db/clientes'

export function useClientes() {
  const [clientes, setClientes] = useState([])
  const [cargando, setCargando] = useState(true)

  const cargar = useCallback(async (termino = '') => {
    try {
      const lista = termino ? await buscarClientes(termino) : await obtenerClientes()
      lista.sort((a, b) => (b.deuda || 0) - (a.deuda || 0))
      setClientes(lista)
    } finally {
      setCargando(false)
    }
  }, [])

  useEffect(() => { cargar() }, [cargar])

  const guardar = useCallback(async (cliente) => {
    await guardarCliente(cliente)
    await cargar()
  }, [cargar])

  const eliminar = useCallback(async (cliente) => {
    await eliminarCliente(cliente)
    await cargar()
  }, [cargar])

  return { clientes, cargando, cargar, guardar, eliminar }
}
